module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_cod_k.bc88a2db.png";